import {TableSelectionAction} from '../../../../../components/tables/actions/TableSelectionAction'
import {TableRowId} from '../../../../../components/tables/TableRow'
import {CustomerModel} from '../../../../../models/CustomerModel'
import {idExtractor} from '../../../../../utils/idExtractor'

export interface CustomerSelectionActionProps {
  selected: TableRowId[]
  items: CustomerModel[]
  onDelete?: (customers: CustomerModel[]) => void
  onSendCredentials?: (customers: CustomerModel[]) => void
}

export const CustomerSelectionAction = ({
  selected,
  items,
  onDelete,
  onSendCredentials,
}: CustomerSelectionActionProps) => {
  return (
    <>
      <TableSelectionAction
        idExtractor={idExtractor}
        items={items}
        selected={selected}
        onClick={onDelete}
        variant='danger'
        filter={customerCanBeDeleted}
      >
        Delete
      </TableSelectionAction>
      <TableSelectionAction
        idExtractor={idExtractor}
        items={items}
        selected={selected}
        onClick={onSendCredentials}
        variant='info'
        filter={customerCanBeSentCredentials}
      >
        Send Credentials
      </TableSelectionAction>
    </>
  )
}

export const customerCanBeSentCredentials = (customer: CustomerModel) => {
  return customer.status === 'pending'
}

export const customerCanBeDeleted = (customer: CustomerModel) => {
  return customer.status === 'pending'
}
